module.exports = __webpack_public_path__ + "img/global__handle.b3c739e6.svg";